import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  Box,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import PreviousStepBtn from "../../components/PreviousStepBtn/PreviousStepBtn";
import FormOperator from "../../components/FormOperator/FormOperator";
import TravelCareItem from "./molecules/TravelCareItem";
import CustomRadio from "../../components/CustomRadio/CustomRadio";
import NextButton from "../../components/NextButton/NextButton";
import TicketProtectionIcon from "../../assets/img/ticket-protection.svg";
import TickIcon from "../../assets/img/tick-care.svg";
import { travelCareData } from "../../constants/travelCareData";
import useStyles from "./styles";
import Accreditation from "../../components/Accreditation/Accreditation";

export default function Step2({
  handleBack,
  handleNext,
  apiData,
  tipsValue,
  selectedFlight,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const { formState, getValues } = useFormContext();
  const errors = formState?.errors?.travelCare || {};
  const show = useMediaQuery(theme.breakpoints.down("xs"));

  const watchTravel = useWatch({ name: "travelCare" });
  const travelCareValue = getValues("travelCare") || watchTravel;

  return (
    <Grid container style={{ height: "100%" }}>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <PreviousStepBtn handleBack={handleBack} />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.headerText}
          >
            <Typography variant="h1" align="center">
              Travel Care Service
            </Typography>
            <Typography variant="body1" align="center">
              Tickets at a good price are almost in your hands!
            </Typography>
          </Box>
        </Box>
        <Box className={classes.travelCareContainer}>
          <Box mb={4} display="flex" alignItems="center">
            <Box ml={2} mr={2}>
              <img src={TickIcon} alt="tick-icon" />
            </Box>
            <Typography variant="h2">Travel Care Service includes:</Typography>
          </Box>
          <Box>
            <Grid container spacing={1}>
              {travelCareData.map((item, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <TravelCareItem item={item} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Grid>
      <Grid
        // container
        item
        xs={12}
        md={4}
        className={classes.secondaryForm}
        justify="center"
        alignItems="center"
      >
        <Box className={classes.ticketCareBox}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              className={classes.ticketIconWrapper}
              mb={2}
            >
              <img src={TicketProtectionIcon} alt="ticket-protection" />
            </Box>
            <Typography variant="h3">Activate Ticket Protection</Typography>
            <Typography variant="body1" align="center">
              Don’t let unpleasant incidents spoil your trip,  let us protect your journey!
              We are here to protect you from any problems you can occur during your flight.
            </Typography>
          </Box>
          <CustomRadio
            name="travelCare"
            defaultValue={travelCareValue}
            travelCareValue={travelCareValue}
            selectedFlight={selectedFlight}
            tipsValue={tipsValue}
          />
          <Box mt={3} mb={3}>
            {!show && (
              <NextButton
                selectedFlight={selectedFlight}
                handleNext={handleNext}
                travelCareValue={travelCareValue}
                disabled={!travelCareValue || !!errors?.message}
                location="form"
                tipsValue={0}
              />
            )}
          </Box>
        </Box>

        <FormOperator operatorInfo={apiData.operatorInfo} />
        <Box width={1}>
          <Accreditation />
        </Box>
      </Grid>
    </Grid>
  );
}
